import Counter from './Counter';
import { GameNode } from './graph';
import NatsObject from './lib/NatsObject';
import Location from './Location';
import StClient from './StClient';
import { Team } from './Team';
import Timer from './Timer';

export type GameData = {
	id: string;
	version: string;
	location_id: string;
	home_team_id: string;
	away_team_id: string;
	start_event_id?: string;
	end_event_id?: string;
	extra?: any;
};

export class Game extends NatsObject<GameData> {
	data: GameNode;
	location?: Location;
	home_team: Team;
	away_team: Team;
	counters: Counter[] = [];
	timers: Timer[] = [];

	constructor(client: StClient, data: GameNode, location?: Location) {
		super(client, data.id);
		this.data = data;
		this.location = location;

		this.home_team = new Team(this.data.home_team, this);
		this.home_team.counters = this.data.counters.nodes.filter((node) => node.team_id === this.home_team.data.id).map((node) => new Counter(node, this, this.home_team));
		this.home_team.timers = this.data.timers.nodes.filter((node) => node.team_id === this.home_team.data.id).map((node) => new Timer(node, this, this.home_team));

		this.away_team = new Team(this.data.away_team, this);
		this.away_team.counters = this.data.counters.nodes.filter((node) => node.team_id === this.away_team.data.id).map((node) => new Counter(node, this, this.away_team));
		this.away_team.timers = this.data.timers.nodes.filter((node) => node.team_id === this.away_team.data.id).map((node) => new Timer(node, this, this.away_team));

		this.counters = this.data.counters.nodes.filter((node) => node.team_id == null).map((node) => new Counter(node, this));
		this.timers = this.data.timers.nodes.filter((node) => node.team_id == null).map((node) => new Timer(node, this));
	}

	updateFromEvent (data: GameData) {
		Object.assign(this.data, data);
	}

	async start () {
		return await this.client.request<GameData>('game.start', {
			id: this.data.id,
			version: this.data.version,
		});
	}

	async end () {
		return await this.client.request<GameData>('game.end', {
			id: this.data.id,
			version: this.data.version,
		});
	}
}

export { Game as default };
